var ImageLoader = /** @class */ (function () {
    function ImageLoader(handlers) {
        this.image = new Image();
        this.image.onload = handlers.onLoad;
        this.image.onerror = handlers.onError;
    }
    ImageLoader.prototype.load = function (src) {
        this.image.src = src;
    };
    ImageLoader.prototype.unsubscribe = function () {
        this.image.onload = function () { };
        this.image.onerror = function () { };
    };
    return ImageLoader;
}());
export default ImageLoader;
//# sourceMappingURL=ImageLoader.js.map